import { isBankAccountViewTypePartnerAch, isBankAccountViewTypeThreadAny } from 'helpers/ui';

export const shouldUseBankAccountDetailsHeader = (viewType) =>
  !isBankAccountViewTypePartnerAch(viewType) && !isBankAccountViewTypeThreadAny(viewType);
